<template>
    <div class="etermin-filial-search etermin-app bg-secondary-l border-radius-main p-4 p-lg-12">
        <etermin :format="format" v-if="proceed" class=""></etermin>
    </div>
</template>

<script>
import Etermin from '@/components/Etermin'
import ServiceDrupal from '@/services/ServiceDrupal.js'
import { mapState } from 'vuex'

export default {
    name: 'etermin-app',
    components: {
        Etermin
    },
    computed: {
        ...mapState([
            'loading',
            'proceed'
        ])
    },
    data () {
        return {
            format: 'normal',
            store: {}
        }
    },
    beforeMount () {
        this.$store.dispatch('activateProceed', null)
        this.store = ServiceDrupal.getStore()
        this.$store.dispatch('setStore', {
            source: 'list',
            store: this.store
        })
    }
}
</script>
